// // src/pages/CloudServices.jsx
// import React from "react";
// import "./ServicePage.css";
// import {
//   FaCloud,
//   FaServer,
//   FaLock,
//   FaCogs,
//   FaDatabase,
//   FaProjectDiagram,
// } from "react-icons/fa";
// import { Link } from "react-router-dom";

// export default function CloudServices() {
//   return (
//     <div className="svc-page">
//       {/* HERO */}
//       <section className="svc-hero">
//         <div className="svc-hero-inner">
//           <div className="svc-hero-left">
//             <span className="svc-hero-tag">Cloud Services</span>
//             <h1 className="svc-hero-title">
//               Modern{" "}
//               <span className="svc-hero-highlight">cloud architecture</span> for
//               your applications.
//             </h1>
//             <p className="svc-hero-subtitle">
//               We help you design, migrate, and operate applications on the cloud
//               with a focus on reliability, cost optimization, and security.
//             </p>

//             <ul className="svc-hero-points">
//               <li>
//                 <span className="svc-bullet">✔</span>
//                 <span>
//                   Cloud-native architecture for greenfield and legacy apps.
//                 </span>
//               </li>
//               <li>
//                 <span className="svc-bullet">✔</span>
//                 <span>CI/CD, monitoring, and infra-as-code baked in.</span>
//               </li>
//               <li>
//                 <span className="svc-bullet">✔</span>
//                 <span>
//                   Multi-environment setups for dev, staging, and production.
//                 </span>
//               </li>
//             </ul>

//             {/* <div className="svc-hero-cta-row">
//               <button className="svc-cta-primary">Plan a Cloud Migration</button>
//               <button className="svc-cta-secondary">
//                 Review Current Infrastructure
//               </button>
//             </div> */}
//           </div>

//           {/* RIGHT VISUAL */}
//           <div className="svc-hero-right">
//             <div className="svc-hero-orbit">
//               <div className="svc-hero-orbit-ring" />
//               <div className="svc-hero-orbit-center">
//                 <FaCloud />
//               </div>

//               <div className="svc-hero-pill-icon svc-hero-pill-top">
//                 <span className="svc-pill-dot" />
//                 <span>Scalable</span>
//               </div>
//               <div className="svc-hero-pill-icon svc-hero-pill-right">
//                 <span className="svc-pill-dot" />
//                 <span>Secure</span>
//               </div>
//               <div className="svc-hero-pill-icon svc-hero-pill-bottom">
//                 <span className="svc-pill-dot" />
//                 <span>Observable</span>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* METRICS */}
//         <div className="svc-hero-metrics">
//           <div className="svc-metric-card">
//             <div className="svc-metric-number">30–50% ↓</div>
//             <div className="svc-metric-label">
//               Infra cost after optimization
//             </div>
//           </div>
//           <div className="svc-metric-card">
//             <div className="svc-metric-number">99.9%</div>
//             <div className="svc-metric-label">
//               Target uptime for key services
//             </div>
//           </div>
//           <div className="svc-metric-card">
//             <div className="svc-metric-number">Minutes</div>
//             <div className="svc-metric-label">To roll out new deployments</div>
//           </div>
//         </div>
//       </section>

//       {/* MAIN CONTENT */}
//       <main className="svc-inner">
//         {/* SERVICES */}
//         <section className="svc-section">
//           <div className="svc-section-header">
//             <h2>Cloud services we offer</h2>
//             <p>
//               From first migration to complex multi-service architectures, we
//               help you use the cloud the right way — not just lift-and-shift.
//             </p>
//           </div>

//           <div className="svc-grid-3">
//             <div className="svc-card">
//               <div className="svc-card-icon">
//                 <FaServer />
//               </div>
//               <h3>Cloud Migration</h3>
//               <p>
//                 Move applications, databases, and file storage to AWS, Azure, or
//                 GCP with minimal downtime and clear rollback plans.
//               </p>
//             </div>

//             <div className="svc-card">
//               <div className="svc-card-icon">
//                 <FaCogs />
//               </div>
//               <h3>Cloud-Native Architecture</h3>
//               <p>
//                 Design microservices, containers, and serverless workloads that
//                 are easier to scale and maintain.
//               </p>
//             </div>

//             <div className="svc-card">
//               <div className="svc-card-icon">
//                 <FaLock />
//               </div>
//               <h3>Security & Governance</h3>
//               <p>
//                 Identity & access management, network segmentation, and security
//                 best practices aligned with your compliance needs.
//               </p>
//             </div>
//           </div>
//         </section>

//         {/* OPERATIONS + STACK */}
//         <section className="svc-section">
//           <div className="svc-section-header">
//             <h2>Reliable operations for your teams</h2>
//             <p>
//               We set up the tooling and processes your developers need to ship
//               confidently on the cloud.
//             </p>
//           </div>

//           <div className="svc-grid-3">
//             <div className="svc-card">
//               <h3>DevOps & CI/CD</h3>
//               <ul className="svc-list">
//                 <li>Automated builds, tests, and deployments.</li>
//                 <li>Environment-specific configs and secrets management.</li>
//                 <li>
//                   Rollback and blue-green / canary strategies where needed.
//                 </li>
//               </ul>
//             </div>

//             <div className="svc-card">
//               <h3>Monitoring & Observability</h3>
//               <ul className="svc-list">
//                 <li>Metrics, logs, and traces connected into one view.</li>
//                 <li>Dashboards and alerts for infrastructure and apps.</li>
//                 <li>Error tracking integrated into your developer workflow.</li>
//               </ul>
//             </div>

//             <div className="svc-card">
//               <h3>Cost Optimization</h3>
//               <ul className="svc-list">
//                 <li>Right-sizing compute, storage, and databases.</li>
//                 <li>
//                   Reserved instances / savings plans where it makes sense.
//                 </li>
//                 <li>Regular reviews and guardrails to avoid bill surprises.</li>
//               </ul>
//             </div>
//           </div>
//         </section>

//         {/* ARCHITECTURE + TOOLS */}
//         <section className="svc-section">
//           <div className="svc-section-header">
//             <h2>Architecture & tooling</h2>
//             <p>
//               We align your stack with the realities of your product roadmap and
//               team size — not just slideware diagrams.
//             </p>
//           </div>

//           <div className="svc-card" style={{ marginBottom: "16px" }}>
//             <div className="svc-card-icon">
//               <FaProjectDiagram />
//             </div>
//             <h3>Typical components we work with</h3>
//             <div className="svc-chip-row" style={{ marginTop: "8px" }}>
//               <span className="svc-chip">AWS / Azure / GCP</span>
//               <span className="svc-chip">Docker & containers</span>
//               <span className="svc-chip">Kubernetes (where needed)</span>
//               <span className="svc-chip">PostgreSQL / MySQL</span>
//               <span className="svc-chip">Managed caches / queues</span>
//               <span className="svc-chip">Terraform / IaC</span>
//             </div>
//           </div>

//           <div className="svc-cta-block">
//             <h3>Need a second opinion on your cloud setup?</h3>
//             <p>
//               Share your current architecture diagram or billing snapshot. We’ll
//               highlight quick wins for reliability, performance, and cost.
//             </p>
//             {/* <button className="svc-cta-primary">
//               Request a Cloud Architecture Review
//             </button> */}
//             <Link to="/contact">
//               <button className="svc-cta-primary">
//                 Request a Cloud Architecture Review
//               </button>
//             </Link>
//           </div>
//         </section>
//       </main>
//     </div>
//   );
// }










// src/pages/CloudServices.jsx
import React from "react";
import "./ServicePage.css";
import {
  FaCloud,
  FaServer,
  FaLock,
  FaCogs,
  FaDatabase,
  FaProjectDiagram,
  FaAws,
  FaDocker,  // Docker icon for containerization
  FaMicrosoft, // Azure icon
} from "react-icons/fa";
import { Link } from "react-router-dom";

export default function CloudServices() {
  return (
    <div className="svc-page">
      {/* HERO */}
      <section className="svc-hero">
        <div className="svc-hero-inner">
          <div className="svc-hero-left">
            <span className="svc-hero-tag">Cloud Services</span>
            <h1 className="svc-hero-title">
              Modern{" "}
              <span className="svc-hero-highlight">cloud architecture</span> for
              your applications.
            </h1>
            <p className="svc-hero-subtitle">
              We help you design, migrate, and operate applications on the cloud
              with a focus on reliability, cost optimization, and security.
            </p>

            <ul className="svc-hero-points">
              <li>
                <span className="svc-bullet">✔</span>
                <span>
                  Cloud-native architecture for greenfield and legacy apps.
                </span>
              </li>
              <li>
                <span className="svc-bullet">✔</span>
                <span>CI/CD, monitoring, and infra-as-code baked in.</span>
              </li>
              <li>
                <span className="svc-bullet">✔</span>
                <span>
                  Multi-environment setups for dev, staging, and production.
                </span>
              </li>
            </ul>
          </div>

          {/* RIGHT VISUAL */}
          <div className="svc-hero-right">
            <div className="svc-hero-orbit">
              <div className="svc-hero-orbit-ring" />
              <div className="svc-hero-orbit-center">
                <FaCloud />
              </div>

              <div className="svc-hero-pill-icon svc-hero-pill-top">
                <span className="svc-pill-dot" />
                <span>Scalable</span>
              </div>
              <div className="svc-hero-pill-icon svc-hero-pill-right">
                <span className="svc-pill-dot" />
                <span>Secure</span>
              </div>
              <div className="svc-hero-pill-icon svc-hero-pill-bottom">
                <span className="svc-pill-dot" />
                <span>Observable</span>
              </div>
            </div>
          </div>
        </div>

        {/* METRICS */}
        <div className="svc-hero-metrics">
          <div className="svc-metric-card">
            <div className="svc-metric-number">30–50% ↓</div>
            <div className="svc-metric-label">
              Infra cost after optimization
            </div>
          </div>
          <div className="svc-metric-card">
            <div className="svc-metric-number">99.9%</div>
            <div className="svc-metric-label">
              Target uptime for key services
            </div>
          </div>
          <div className="svc-metric-card">
            <div className="svc-metric-number">Minutes</div>
            <div className="svc-metric-label">To roll out new deployments</div>
          </div>
        </div>
      </section>

      {/* TECHNOLOGIES WE USE */}
      <section className="svc-section">
        <div className="svc-section-header">
          <h2>Technologies We Use</h2>
          <p>
            We leverage modern cloud technologies to design, migrate, and operate
            your applications efficiently.
          </p>
        </div>

        <div className="svc-grid-3">
          <div className="svc-card">
            <div className="svc-card-icon">
              <FaAws />
            </div>
            <h3>AWS</h3>
            <p>
              Amazon Web Services provides a comprehensive suite of cloud
              services that help scale applications quickly and efficiently.
            </p>
          </div>

          <div className="svc-card">
            <div className="svc-card-icon">
              <FaDocker />
            </div>
            <h3>Docker</h3>
            <p>
              Docker enables containerization, which allows applications to run
              seamlessly across different environments.
            </p>
          </div>

          <div className="svc-card">
            <div className="svc-card-icon">
              <FaMicrosoft />
            </div>
            <h3>Azure</h3>
            <p>
              Microsoft Azure provides cloud computing services for building,
              testing, deploying, and managing applications and services.
            </p>
          </div>
        </div>
      </section>

      {/* MAIN CONTENT */}
      <main className="svc-inner">
        {/* SERVICES */}
        <section className="svc-section">
          <div className="svc-section-header">
            <h2>Cloud services we offer</h2>
            <p>
              From first migration to complex multi-service architectures, we
              help you use the cloud the right way — not just lift-and-shift.
            </p>
          </div>

          <div className="svc-grid-3">
            <div className="svc-card">
              <div className="svc-card-icon">
                <FaServer />
              </div>
              <h3>Cloud Migration</h3>
              <p>
                Move applications, databases, and file storage to AWS, Azure, or
                GCP with minimal downtime and clear rollback plans.
              </p>
            </div>

            <div className="svc-card">
              <div className="svc-card-icon">
                <FaCogs />
              </div>
              <h3>Cloud-Native Architecture</h3>
              <p>
                Design microservices, containers, and serverless workloads that
                are easier to scale and maintain.
              </p>
            </div>

            <div className="svc-card">
              <div className="svc-card-icon">
                <FaLock />
              </div>
              <h3>Security & Governance</h3>
              <p>
                Identity & access management, network segmentation, and security
                best practices aligned with your compliance needs.
              </p>
            </div>
          </div>
        </section>

        {/* OPERATIONS + STACK */}
        <section className="svc-section">
          <div className="svc-section-header">
            <h2>Reliable operations for your teams</h2>
            <p>
              We set up the tooling and processes your developers need to ship
              confidently on the cloud.
            </p>
          </div>

          <div className="svc-grid-3">
            <div className="svc-card">
              <h3>DevOps & CI/CD</h3>
              <ul className="svc-list">
                <li>Automated builds, tests, and deployments.</li>
                <li>Environment-specific configs and secrets management.</li>
                <li>
                  Rollback and blue-green / canary strategies where needed.
                </li>
              </ul>
            </div>

            <div className="svc-card">
              <h3>Monitoring & Observability</h3>
              <ul className="svc-list">
                <li>Metrics, logs, and traces connected into one view.</li>
                <li>Dashboards and alerts for infrastructure and apps.</li>
                <li>Error tracking integrated into your developer workflow.</li>
              </ul>
            </div>

            <div className="svc-card">
              <h3>Cost Optimization</h3>
              <ul className="svc-list">
                <li>Right-sizing compute, storage, and databases.</li>
                <li>
                  Reserved instances / savings plans where it makes sense.
                </li>
                <li>Regular reviews and guardrails to avoid bill surprises.</li>
              </ul>
            </div>
          </div>
        </section>

        {/* ARCHITECTURE + TOOLS */}
        <section className="svc-section">
          <div className="svc-section-header">
            <h2>Architecture & tooling</h2>
            <p>
              We align your stack with the realities of your product roadmap and
              team size — not just slideware diagrams.
            </p>
          </div>

          <div className="svc-card" style={{ marginBottom: "16px" }}>
            <div className="svc-card-icon">
              <FaProjectDiagram />
            </div>
            <h3>Typical components we work with</h3>
            <div className="svc-chip-row" style={{ marginTop: "8px" }}>
              <span className="svc-chip">AWS / Azure / GCP</span>
              <span className="svc-chip">Docker & containers</span>
              <span className="svc-chip">Kubernetes (where needed)</span>
              <span className="svc-chip">PostgreSQL / MySQL</span>
              <span className="svc-chip">Managed caches / queues</span>
              <span className="svc-chip">Terraform / IaC</span>
            </div>
          </div>

          <div className="svc-cta-block">
            <h3>Need a second opinion on your cloud setup?</h3>
            <p>
              Share your current architecture diagram or billing snapshot. We’ll
              highlight quick wins for reliability, performance, and cost.
            </p>
            <Link to="/contact">
              <button className="svc-cta-primary">
                Request a Cloud Architecture Review
              </button>
            </Link>
          </div>
        </section>
      </main>
    </div>
  );
}
